import React, { Component } from 'react';
import STEP from '$components/review/step';
import MODE from '$components/review/mode';
import logger from '$lib/logger';
import QuizExplanation from '../QuizExplanation';
import QuizGenericMultipleChoice from '../QuizGenericMultipleChoice';
import QuizPassageChooseSentence from '../QuizPassageChooseSentence';
import QuizNumeric from '../QuizNumeric';
import QuizQuantityComparison from '../QuizQuantityComparison';
import SessionOptions from '../SessionOptions';
import SessionSelect from '../SessionSelect';
import Loading from '../Loading';
import ShareSummary from '../ShareSummary';
import Summary from '../Summary';
import ExamNavigation from '../ExamNavigation';
import ExamReview from '../ExamReview';
import ExamSummary from '../ExamSummary';
import EssayInstructions from '../essay/EssayInstructions';
import EssayWriting from '../essay/EssayWriting';
import EssayResults from '../essay/EssayResults';

import styles from './styles.scss';

class ReviewContent extends Component {
  renderContent = () => {
    const {
      handleChoice,
      handleEssayOnChange,
      handleEssaySave,
      handleEssayStart,
      handleFinishExam,
      handleInput,
      handleQueueNavigation,
      handleToggleShowPassage,
      mode,
      productSlug,
      quizState,
      setOptions,
    } = this.props;
    const { step } = quizState;

    switch (step) {
      case STEP.loading: {
        return <Loading />;
      }
      case STEP.essayInstructions: {
        return <EssayInstructions handleEssayStart={handleEssayStart} />;
      }
      case STEP.essayWriting: {
        return (
          <EssayWriting
            handleEssayOnChange={handleEssayOnChange}
            handleEssaySave={handleEssaySave}
            quizState={quizState}
          />
        );
      }
      case STEP.essayReview: {
        return <EssayResults quizState={quizState} />;
      }
      case STEP.examNavigation: {
        return (
          <ExamNavigation
            handleQueueNavigation={handleQueueNavigation}
            quizState={quizState}
          />
        );
      }
      case STEP.examReview: {
        return <ExamReview handleFinishExam={handleFinishExam} quizState={quizState} />;
      }
      case STEP.examSummary: {
        return (
          <ExamSummary
            quizState={quizState}
            handleQueueNavigation={handleQueueNavigation}
          />
        );
      }
      case STEP.sessionOptions: {
        return (
          <SessionOptions
            productSlug={productSlug}
            quizState={quizState}
            setOptions={setOptions}
          />
        );
      }
      case STEP.sessionSelect: {
        return (
          <SessionSelect
            productSlug={productSlug}
            quizState={quizState}
            setOptions={setOptions}
          />
        );
      }
      case STEP.quizPrompt:
      case STEP.quizConfirmation: {
        const { examQueueIndex, quizQueue } = quizState;

        const quizObj = mode === MODE.exam ? quizQueue[examQueueIndex] : quizQueue[0];

        const { quiz } = quizObj;
        const { evaluated } = quiz;
        const itemType = evaluated.itemType || 'multipleChoice';

        const QUIZ_COMPONENTS = {
          actEnglishMultipleChoice: QuizGenericMultipleChoice,
          clozeDeletion: QuizGenericMultipleChoice,
          multipleChoice: QuizGenericMultipleChoice,
          numeric: QuizNumeric,
          passageChooseMany: QuizGenericMultipleChoice,
          passageChooseOne: QuizGenericMultipleChoice,
          passageChooseSentence: QuizPassageChooseSentence,
          quantityComparison: QuizQuantityComparison,
          selectMultiple: QuizGenericMultipleChoice,
          sentenceEquivalence: QuizGenericMultipleChoice,
        };

        const QuizComponent = QUIZ_COMPONENTS[itemType];

        if (!QuizComponent) {
          logger.warn(`Unknown itemType: ${itemType}`);
          return null;
        }

        return (
          <QuizComponent
            handleChoice={handleChoice}
            handleInput={handleInput}
            handleToggleShowPassage={handleToggleShowPassage}
            mode={mode}
            quizObj={quizObj}
            quizState={quizState}
          />
        );
      }
      case STEP.quizExplanation: {
        const { examQueueIndex, quizQueue } = quizState;

        const quizObj = mode === MODE.exam ? quizQueue[examQueueIndex] : quizQueue[0];

        return <QuizExplanation mode={mode} quizObj={quizObj} quizState={quizState} />;
      }
      case STEP.summary: {
        if (mode === MODE.share) {
          return <ShareSummary quizState={quizState} />;
        }

        return <Summary quizState={quizState} />;
      }
      default: {
        logger.warn(`[ReviewContent] Unknown step: ${step}`);
        return null;
      }
    }
  };

  render() {
    return <div className={styles.layout}>{this.renderContent()}</div>;
  }
}

export default ReviewContent;
